// @packages
import { combineReducers } from 'redux';
import _ from 'lodash';
// @scripts
import {
    ADD_ITEM_TO_SCHEDULE,
    ADD_ITEM_TO_SCHEDULE_IMPORT,
    CLEAR_CANDIDATE_PRODUCTS,
    GET_CANDIDATE_PRODUCTS,
    GET_SCHEDULE_PRODUCTS,
    REMOVE_ITEMS_FROM_SCHEDULE,
    UPDATE_ITEM_FROM_SCHEDULE,
    GET_SEARCH_INPUTS
} from '../actions';

import { config } from '../config';

/**
 * @returns {boolean}
 */
const candidateProductsReducer = (
    state = config.initialState.product.candidateProducts, action
) => {
    switch (action.type) {
        case GET_CANDIDATE_PRODUCTS:
            return action.payload;
        case CLEAR_CANDIDATE_PRODUCTS:
            return [];
        default:
            return state;
    }
};

const searchInputsReducer = (
    state = config.initialState.product.searchInputs, action
) => {
    switch (action.type) {
        case GET_SEARCH_INPUTS:
            return action.payload;
        default:
            return state;
    }
};

const scheduleItemsReducer = (
    state = config.initialState.product.scheduleItems, action
) => {
    
    switch (action.type) {
        case ADD_ITEM_TO_SCHEDULE_IMPORT:
            return  _.concat(state, action.payload);
        case ADD_ITEM_TO_SCHEDULE:
            return [...state, action.payload];
        case REMOVE_ITEMS_FROM_SCHEDULE:
            return state.filter((itemState) => !action.payload.some((item) => item === itemState));
        case UPDATE_ITEM_FROM_SCHEDULE:
            const nextState = Array.from(state);
            nextState[action.payload.rowIndex][action.payload.item.columnKey] = action.payload.item.value;
            return nextState;
        default:
            return state;
    }
};

const scheduleProductsReducer = (
    state = config.initialState.product.scheduleProducts, action
) => {
    switch (action.type) {
        case GET_SCHEDULE_PRODUCTS:
            return action.payload;
        default:
            return state;
    }
};

export const productReducer = combineReducers({
    candidateProducts: candidateProductsReducer,
    scheduleItems: scheduleItemsReducer,
    scheduleProducts: scheduleProductsReducer,
    searchInputs: searchInputsReducer
});
